import { OTPDeliveryStatusResult } from '@ads-bread/shared/bread/codecs';
import { poll } from '../poll';
import { APIFetch } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const OTP_DELIVERY_STATUS_URI = '/api/auth/code/{referenceID}/status';

/**
 *
 * @param referenceID The reference ID returned from sendCode handler
 * @param apiFetch The API fetch function to use for making requests
 * @returns  Promise<HandlerResponse<OTPDeliveryStatusResult>>
 */
export async function getOTPDeliveryStatus(
  referenceID: string,
  apiFetch: APIFetch
): Promise<HandlerResponse<OTPDeliveryStatusResult>> {
  const response = await apiFetch<OTPDeliveryStatusResult>(
    OTP_DELIVERY_STATUS_URI.replace('{referenceID}', referenceID),
    { method: 'GET' },
    OTPDeliveryStatusResult
  );
  return handleResponse(response);
}

/**
 * Polls for delivery status of the OTP code until it is delivered or max attempts is reached.
 * @param referenceID The reference ID returned from sendCode handler
 * @param apiFetch The API fetch function to use for making requests
 * @param delay The delay between each poll attempt in milliseconds
 * @param maxAttempts The maximum number of poll attempts
 * @returns Promise<HandlerResponse<OTPDeliveryStatusResult>
 */
export async function pollOTPDeliveryStatus(
  referenceID: string,
  apiFetch: APIFetch,
  delay = 3000,
  maxAttempts = 12
): Promise<HandlerResponse<OTPDeliveryStatusResult>> {
  return await poll(
    () => getOTPDeliveryStatus(referenceID, apiFetch),
    (response) => {
      if (response.error || response?.result?.status === 'FAILURE') {
        throw new Error('OTP delivery failed.');
      }
      return response?.result?.status === 'SUCCESS';
    },
    delay,
    maxAttempts
  );
}
